import React from 'react';
import LuckyWheelForm from './form';
import {notification} from 'antd';
import history from '../../modules/History';
import {getLuckyWheel, updateLuckyWheel} from '../../modules/Api';

class EditLuckyWheel extends React.Component {
    constructor() {
        super();
        this.state = {
            data: {},
            submitted: false,
        }

    }

    componentDidMount() {
        const id = this.props.match.params.id;
        getLuckyWheel(id, (res)=>{
            if(res.status==200){
                this.setState({data: res.data});
            }
        });
    }

    submit(values) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});
        updateLuckyWheel(this.state.data.id, values, (res) => {
            this.setState({submitted:false});

            if(res.status==200){
                notification.open({
                    message: `اطلاعات با موفقیت ویرایش شد!`,
                });
                history.item.push(`/lucky_wheels`);
            }
            else if(res.message != undefined){
                notification.open({
                    message: res.message,
                });
            }
        });
    }
    render() {
        if(this.state.data.id == undefined){
            return 'لطفا منتظر بمانید';
        }
        return (<LuckyWheelForm initialData={this.state.data} submit={this.submit.bind(this)} submitted={this.state.submitted}/>);
    }
}

export default EditLuckyWheel;


// WEBPACK FOOTER //
// ./src/containers/LuckyWheels/edit.js